import script from "./UserProfileOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfileOrders.vue?vue&type=script&setup=true&lang=js"

import "./UserProfileOrders.vue?vue&type=style&index=0&id=08b06232&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08b06232"]])

export default __exports__